//angular
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

//local
import { SecurityConfig } from '@app/core';
import { ApiConstants, HttpParamHelper, HttpResult, PollyHttpHelper } from '@app/shared';
import { DepartmentPropertyDto, CreateDepartmentRequest, UpdateDepartmentRequest } from '@app/catalog';

@Injectable({
    providedIn: 'root'
})
export class DepartmentHttpService 
{
    constructor(
      private http: HttpClient, 
      private applicationConfig: SecurityConfig) {    
    }


    public getProperties(departmentId: string, programId?: string, projectId?: string): HttpResult<DepartmentPropertyDto> 
    {
      const queryParams: Record<string, string | undefined> = {
        programId,
        projectId
      }
    
      const params = HttpParamHelper.toHttpParams(queryParams);

      let serviceUri = `${this.applicationConfig.applicationUri}/v2/catalog/department/${departmentId}`;
            
      console.log(`GET: ${serviceUri}`, params.toString()); 
      
      return PollyHttpHelper.Invoke('GET', () => this.http.get<DepartmentPropertyDto>(serviceUri, { headers: ApiConstants.DefaultHeaders, params }));
    }

    public create(request: CreateDepartmentRequest): HttpResult<Object> 
    {      
      let serviceUri = `${this.applicationConfig.applicationUri}/v2/department`;
            
      console.log(`POST: ${serviceUri}`); 
      console.log(request);
            
      return PollyHttpHelper.Invoke('POST', () => this.http.post<Object>(serviceUri, request, { headers: ApiConstants.DefaultHeaders }));
    }

    public update(deparmentId: string, request: UpdateDepartmentRequest): HttpResult<Object> 
    {      
      let serviceUri = `${this.applicationConfig.applicationUri}/v2/department/${deparmentId}`;
            
      console.log(`PUT: ${serviceUri}`); 
      console.log(request);
            
      return PollyHttpHelper.Invoke('PUT', () => this.http.put<Object>(serviceUri, request, { headers: ApiConstants.DefaultHeaders }));
    }
}